module.exports = __webpack_public_path__ + "img/电动自行车智能充电站方案1.059fe3ce.png";